<template>
  <input-number
    v-model="input"
    :config="config"
    :size="size"
  />
</template>

<script>
import InputNumber from '@/components/base/InputNumber.vue';

export default {
  name: 'FilterElementNumber',
  components: { InputNumber },
  props: {
    config: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: 'default',
    },
  },
  data() {
    return {
      value: undefined,
    };
  },
  computed: {
    input: {
      get() {
        return this.value;
      },
      set(value) {
        this.value = value;
        this.$emit('input', value);
      },
    },
  },
};
</script>
